import React from 'react';

// Small national flag glyphs used only as a service-profile identifier.
// These are simplified, generic national flags — not military branch
// insignia, crests, or roundels.
const CanadaFlag = () => (
  <svg viewBox="0 0 24 16" width="20" height="14" role="img" aria-label="Canadian flag">
    <rect width="24" height="16" fill="#ff3333" />
    <rect x="6" width="12" height="16" fill="#f4f6f8" />
    <path d="M12 3.2l1 2.1 2.2-.5-.9 2 1.9 1.1-2.1.6.3 2.2-1.4-.9v1.8h-2.2V9.8l-1.4.9.3-2.2-2.1-.6 1.9-1.1-.9-2 2.2.5z" fill="#ff3333" />
  </svg>
);

const UkFlag = () => (
  <svg viewBox="0 0 24 16" width="20" height="14" role="img" aria-label="United Kingdom flag">
    <rect width="24" height="16" fill="#0a1f6e" />
    <path d="M0 0l24 16M24 0L0 16" stroke="#f4f6f8" strokeWidth="3" />
    <path d="M0 0l24 16M24 0L0 16" stroke="#ff3333" strokeWidth="1.2" />
    <path d="M12 0v16M0 8h24" stroke="#f4f6f8" strokeWidth="5" />
    <path d="M12 0v16M0 8h24" stroke="#ff3333" strokeWidth="2.2" />
  </svg>
);

const AustraliaFlag = () => (
  <svg viewBox="0 0 24 16" width="20" height="14" role="img" aria-label="Australian flag">
    <rect width="24" height="16" fill="#0a1f6e" />
    <g transform="translate(0,0) scale(0.5)">
      <path d="M0 0l24 16M24 0L0 16" stroke="#f4f6f8" strokeWidth="3" />
      <path d="M0 0l24 16M24 0L0 16" stroke="#ff3333" strokeWidth="1.2" />
      <path d="M12 0v16M0 8h24" stroke="#f4f6f8" strokeWidth="5" />
      <path d="M12 0v16M0 8h24" stroke="#ff3333" strokeWidth="2.2" />
    </g>
    {[[19, 4], [21, 8], [19, 12], [16, 9], [16.5, 6.5]].map(([cx, cy], index) => (
      <circle key={index} cx={cx} cy={cy} r={index === 4 ? 0.5 : 0.7} fill="#f4f6f8" />
    ))}
  </svg>
);

const FLAGS = {
  ca: CanadaFlag,
  gb: UkFlag,
  au: AustraliaFlag
};

// `large` sizes the flag up (34 x 23) for where it is the point of the
// element, like the dashboard's training profile.
const ServiceFlag = ({ flag, className = '', large = false }) => {
  const Glyph = FLAGS[flag];
  if (!Glyph) return null;
  return (
    <span
      className={`inline-flex shrink-0 overflow-hidden rounded-[2px] border border-[#2b425a] ${large ? '[&>svg]:h-[23px] [&>svg]:w-[34px]' : ''} ${className}`}
    >
      <Glyph />
    </span>
  );
};

export default ServiceFlag;
